import { render, staticRenderFns } from "./Terminal.vue?vue&type=template&id=19af0175&"
import script from "./Terminal.vue?vue&type=script&lang=ts&"
export * from "./Terminal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19af0175')) {
      api.createRecord('19af0175', component.options)
    } else {
      api.reload('19af0175', component.options)
    }
    module.hot.accept("./Terminal.vue?vue&type=template&id=19af0175&", function () {
      api.rerender('19af0175', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Terminal.vue"
export default component.exports